import { useState, useEffect, useMemo } from 'react';
import { doc, onSnapshot, collection, query, where, orderBy, getDocs, collectionGroup } from 'firebase/firestore';
import { db } from '../../../firebase';

export const useCustomerDetail = (id) => {
    const [customer, setCustomer] = useState(null);
    const [devices, setDevices] = useState([]);
    const [serviceHistory, setServiceHistory] = useState([]);
    const [communicationLog, setCommunicationLog] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);

        const unsubCustomer = onSnapshot(doc(db, "customers", id), (docSnap) => {
            if (docSnap.exists()) {
                setCustomer({ id: docSnap.id, ...docSnap.data() });
            }
        });

        const unsubDevices = onSnapshot(query(collection(db, "devices"), where("musteriId", "==", id)), (snapshot) => {
            const devicesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            // Client-side sıralama - hem createdAt hem eklenmeTarihi desteklenir
            devicesData.sort((a, b) => {
                const dateA = a.eklenmeTarihi || a.createdAt;
                const dateB = b.eklenmeTarihi || b.createdAt;
                if (!dateA) return 1;
                if (!dateB) return -1;
                return (dateB.toMillis?.() || 0) - (dateA.toMillis?.() || 0);
            });
            setDevices(devicesData);
        });

        const unsubServiceHistory = onSnapshot(query(collection(db, "serviceRecords"), where("musteriId", "==", id), orderBy("olusturmaTarihi", "desc")), (snapshot) => {
            const records = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setServiceHistory(records);
            setLoading(false);
        }, (error) => {
            console.error("Servis geçmişi çekilirken hata:", error);
            setLoading(false);
        });

        const fetchLogs = async () => {
            try {
                const logQuery = query(collectionGroup(db, 'communicationLog'), where('musteriId', '==', id), orderBy('timestamp', 'desc'));
                const logSnapshot = await getDocs(logQuery);
                const allLogs = logSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                setCommunicationLog(allLogs);
            } catch (error) {
                console.error("İletişim geçmişi çekilirken hata:", error);
            }
        };

        fetchLogs();

        return () => {
            unsubCustomer();
            unsubDevices();
            unsubServiceHistory();
        };
    }, [id]);

    const financialSummary = useMemo(() => {
        return serviceHistory.reduce((acc, record) => {
            acc.total += record.toplamTutar || 0;
            acc.paid += record.odenenTutar || 0;
            return acc;
        }, { total: 0, paid: 0 });
    }, [serviceHistory]);

    const balance = useMemo(() => {
        // Öncelik müşteri kartındaki güncel bakiyedir (Manuel işlemler dahil)
        if (customer && customer.bakiye !== undefined) {
            return customer.bakiye;
        }
        // Fallback: Servis geçmişinden hesapla (Eski kayıtlar için)
        return financialSummary.total - financialSummary.paid;
    }, [customer, financialSummary]);

    return {
        customer,
        devices,
        serviceHistory,
        communicationLog,
        loading,
        financialSummary,
        balance
    };
};
